import { usePostApiTimesheetsDelete, } from '../../generated/sitComponents';
import { removeEmployeeOvertimeCalculations } from '../employees/query';
import { invalidateTimesheetsQuery, setTimesheetsQueryData, timesheetsPredicate, timesheetsQueryKey, } from './query';
// https://tanstack.com/query/v5/docs/react/guides/optimistic-updates#via-the-cache
export function useDeleteTimesheets(options) {
    return usePostApiTimesheetsDelete({
        ...options,
        onMutate: async (variables, context) => {
            // Cancel any outgoing refetches
            // (so they don't overwrite our optimistic update)
            await context.client.cancelQueries({ queryKey: timesheetsQueryKey });
            // Snapshot the previous value
            const queriesData = context.client.getQueriesData({
                queryKey: timesheetsQueryKey,
                predicate: timesheetsPredicate,
            });
            // Optimistically update to the new value (doesn't work for infinite queries)
            setTimesheetsQueryData(context.client, (old) => old?.filter((timesheet) => !variables.body?.id?.includes(timesheet.id)));
            options?.onMutate?.(variables, context);
            // Return a context object with the snapshotted value
            return {
                queriesData,
            };
        },
        // If the mutation fails,
        // use the context returned from onMutate to roll back
        onError: (error, variables, onMutateResult, context) => {
            for (const [key, value] of onMutateResult.queriesData) {
                context.client.setQueriesData({ queryKey: key }, value);
            }
            options?.onError?.(error, variables, onMutateResult, context);
        },
        // Always refetch after error or success:
        onSettled: async (data, error, variables, onMutateResult, context) => {
            await invalidateTimesheetsQuery(context.client);
            // Collect all employeeIds from deleted timesheets in the context snapshot
            const deletedIds = new Set(variables.body.id);
            const queriesData = onMutateResult
                .queriesData;
            const employeeIds = new Set();
            for (const [, timesheets] of queriesData) {
                if (!timesheets)
                    continue;
                for (const t of timesheets) {
                    if (deletedIds.has(t.id)) {
                        employeeIds.add(t.employeeId);
                        if (employeeIds.size === deletedIds.size)
                            break;
                    }
                }
            }
            for (const employeeId of employeeIds) {
                // Remove rather than invalidate to prevent flicker.
                removeEmployeeOvertimeCalculations(context.client, employeeId);
            }
            options?.onSettled?.(data, error, variables, onMutateResult, context);
        },
    });
}
//# sourceMappingURL=use-post-api-timesheets-delete.js.map